import {
  BuildingsIcon,
  CalculateIcon,
  CommentWordsIcon,
  HandyManIcon,
  HomeFavoriteIcon,
  HomeIcon,
  MoneyAltIcon,
  PeopleIcon,
  RealEstateAgentIcon,
  ReportsIcon,
  SettingsIcon,
} from '@fortress-technology-solutions/fortress-component-library/Icons';
import React from 'react';

export const drawerWidth = { closed: 64, open: 210 };

export const prorateCalculator = 'Prorate Calculator';
export const manageMincTransactions = 'Manage MINC Transactions';
export const managePicTransactions = 'Manage PIC Transactions';
export const manageAffordableWaitlist = 'Manage Affordable Waitlist';
export const affordableHousing = 'Affordable Housing';
export const unitCompliance = 'Unit Compliance';

// Options here are DISPLAYED when the named LaunchDarkly flag is ON.
export const featureFlagNameMap = {
  'Prorate Calculator': 'prorateCalculatorV1',
  'Manage Online Payments': 'paymentsV1',
  'Manage Amenities': 'manageAmenitiesV1',
  'Manage Fees': 'manageFeesV1',
  'Forecast Rents': 'forecastRents',
  'RD Budgets': 'rdBudgets',
  'Sales-portfolioSummaryOnly': 'centralizedUnitAvailability',
  'People-portfolioSummaryOnly': 'centralizedExpiringLeases',
  'Manage Expiring Leases-portfolioSummaryOnly': 'centralizedExpiringLeases',
  'Manage Documents-portfolioSummaryOnly': 'documentManagementMvp',
  'Manage Delinquent and Prepaid-portfolioSummaryOnly':
    'centralizedDelinquencyAndPrepaid',
  Communications: 'messagingHub',
  'Communications-portfolioSummaryOnly': 'messagingHub',
  'Manage HUD Vouchers': 'hudManageVouchers',
  'Manage Gross Rents': 'updatedHudGrcLogic',
  'Unit Compliance': 'naur',
  'Lead Management': 'leadManagementFunnel',
  'Certification approvals': 'certApprovalFunnel',
};

// Options here are HIDDEN when the named LaunchDarkly flag is ON.
// Key shape: `${name}@${parentName}` to disambiguate same-named records under
// different parents. For top-level (parentless) options, use the bare name.
export const inverseFeatureFlagNameMap = {
  'Manage Communications@People': 'messagingHub', // People/Manage Communications
};

const ICON_PROPS = {
  fontSize: 'small',
};
export const NAV_ICON_MAP = {
  Home: <HomeIcon {...ICON_PROPS} />,
  Sales: <RealEstateAgentIcon {...ICON_PROPS} />,
  People: <PeopleIcon {...ICON_PROPS} />,
  Communications: <CommentWordsIcon {...ICON_PROPS} />,
  Property: <BuildingsIcon {...ICON_PROPS} />,
  Financials: <MoneyAltIcon {...ICON_PROPS} />,
  Maintenance: <HandyManIcon {...ICON_PROPS} />,
  Reporting: <ReportsIcon {...ICON_PROPS} />,
  Admin: <SettingsIcon {...ICON_PROPS} />,
  [prorateCalculator]: <CalculateIcon {...ICON_PROPS} />,
  [affordableHousing]: <HomeFavoriteIcon {...ICON_PROPS} />,
};

export const HOVER_DELAY = 350;

export const BASE_LIST_SX = ({
  navigationMenuUxImprovements,
  leftsideNavButton,
}) => ({
  position: 'absolute',
  top: 0,
  paddingTop: 0,
  height: '100%',
  overflowY: 'auto',
  scrollbarWidth: 'thin',
  transition: ({ transitions: { create, duration, easing } }) =>
    create('opacity', {
      duration: duration.short,
      easing: easing.easeOut,
      delay: duration.short,
    }),
  ...(navigationMenuUxImprovements && {
    scrollbarGutter: 'stable',
  }),
  ...(!leftsideNavButton && {
    scrollbarGutter: 'stable both-edges',
  }),
});
